import { type SVGProps } from 'react'

/**
 * AKM with furniture but no magazine (empty mag well). Replace with svgmaker output when ready.
 */
export function AkmNoMagazine (props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={1536}
      height={1024}
      viewBox="0 0 900 320"
      preserveAspectRatio="xMidYMid meet"
      style={{ display: 'block' }}
      {...props}
    >
      <defs>
        <linearGradient id="nm-body" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#2A3140" />
          <stop offset="100%" stopColor="#1A1F28" />
        </linearGradient>
        <linearGradient id="nm-wood" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#5C4030" />
          <stop offset="100%" stopColor="#3D2818" />
        </linearGradient>
      </defs>
      <path fill="#F5F5F0" d="M0 0h900v320H0z" />
      {/* Barrel */}
      <path
        fill="url(#nm-body)"
        stroke="#4A5568"
        strokeWidth="1.5"
        d="M 80 148 L 380 142 L 382 158 L 82 162 Z"
      />
      {/* Receiver */}
      <path
        fill="url(#nm-body)"
        stroke="#4A5568"
        strokeWidth="1.5"
        d="M 380 130 L 620 128 L 628 210 L 400 214 L 378 200 Z"
      />
      {/* Stock */}
      <path fill="url(#nm-wood)" stroke="#3D2818" strokeWidth="1.5" d="M 628 136 L 860 132 L 868 188 L 632 198 Z" />
      {/* Pistol grip */}
      <path fill="url(#nm-wood)" stroke="#3D2818" strokeWidth="1.5" d="M 470 208 L 520 208 L 530 288 L 490 292 L 458 230 Z" />
      {/* Upper handguard */}
      <path fill="#3D4454" stroke="#5A6570" strokeWidth="1.2" d="M 200 128 L 370 124 L 372 142 L 202 146 Z" />
      {/* Lower handguard */}
      <path fill="#3D4454" stroke="#5A6570" strokeWidth="1.2" d="M 200 166 L 370 164 L 372 182 L 202 180 Z" />
      {/* Empty mag well — negative space + lip */}
      <path fill="#E8E6E0" stroke="#6B7280" strokeWidth="1.5" d="M 450 208 L 530 206 L 532 228 L 448 232 Z" />
      <path fill="none" stroke="#9CA3AF" strokeWidth="1" d="M 454 212 L 526 210" />
    </svg>
  )
}
